import React, { Component } from 'react';

class EthereumInstructions extends Component {
    render() {
        return (
                    <div className="ethereum-instructions">
                      <div className="ethereum-action">
                        1. You need the Metamask Chrome-plugin to connect Universal Sequences with Ethereum. Install it <a href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en"> here </a>. Unless you have it installed, but are not logged in. If so click on the metamask and type your password.
                      </div>
                      <div className="ethereum-action">
                        2. Watch the first minute of this <a href="https://www.youtube.com/watch?v=6Gf_kRE4MJU"> video </a> to learn how to set up a new account. All sounds you sample and tracks you create will be tied to the account you have logged on in Metamask.
                      </div>
                      <div className="ethereum-action">
                        3. Switch to the "Ropsten" test network on Metamask
                      </div>
                      <div className="ethereum-action">
                        <img src="/metamask-ropsten.png"/>
                      </div>
                      <div className="ethereum-action">
                        4. Get free test Ether from this <a href="https://faucet.metamask.io/"> website </a> and clicking the "request 1 ether from faucet" button.
                      </div>
                      <div className="ethereum-action">
                        5. Reload this page and choose a user name. When you choose your name, Metamask will pop-up asking you to confirm a transaction, costing some (free) Ether. It's test money (i.e. not worth anything) so go ahead and click "Confirm".
                      </div>
                      <div className="ethereum-action">
                        6. Go to the <a href="/sequencer/"> sequencer </a> page and make a track. When you hit save, a Metamask pop-up will ask you to confirm that transaction. Whenever we save stuff (whether new sounds or tracks), you will need to confirm the transaction and cough up free test Ether.
                      </div>
                      <div className="ethereum-action">
                        7. Finally, have fun.
                      </div>
                    </div>
        );
    }
}

export default EthereumInstructions;
